module.exports = __webpack_public_path__ + "img/multiple-actions-address.58e94074.svg";